module.exports = "<div class=\"not-found\">\r\n  <div align=\"center\"><h1>404 Page not found</h1></div>\r\n  <hr>\r\n  <div align=\"center\"><a href=\"/\">Link</a></div>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/not-found/not-found.component.html
// module id = ./src/app/not-found/not-found.component.html
// module chunks = main